namespace Ir.Components.General.ForeignKeyInfo {

    interface IViewModel {
        tabOptions: DevExpress.ui.dxTabPanel.Properties;
    }

    let popupComponent: DevExpress.ui.dxPopup;
    let tabComponent: DevExpress.ui.dxTabPanel;
    let config: IForeignKeyInfoParams;

    export interface IForeignKeyInfoParams {
        title: string;
        url: string;
        tabs: Array<any>;

        createTabs: (data) => Array<any>;
        onRowPrepared: (e) => void;
    }

    export function getViewModel(this: IViewModel) {
        this.tabOptions = {
            activeStateEnabled: true,
            dataSource: config.tabs,
            itemTitleTemplate: function (data, index, element) {
                return `${data.name} (${data.dataSource.length})`;
            },
            itemTemplate: function (data, index, element) {
                element.dxDataGrid({
                    height: 380,
                    dataSource: data.dataSource,
                    columns: data.columns,
                    paging: {
                        enabled: false
                    },
                    searchPanel: {
                        visible: true
                    },
                    selection: {
                        mode: "single"
                    },
                    scrolling: {
                        useNative: false
                    },
                    onRowPrepared(e) {
                        if (config.onRowPrepared) {
                            config.onRowPrepared(e);
                        }
                    }
                });
            },
            onInitialized(e) {
                tabComponent = e.component;
            }
        }
    }
    
    export function show(options: IForeignKeyInfoParams) {
        config = options;
        load(config);

        if (popupComponent) {
            tabComponent.option("dataSource", config.tabs);
            popupComponent.option("title", config.title);
            popupComponent.show();
        }
        else {
            let popupOptions = {
                width: 700,
                height: 510,
                showTitle: true,
                title: config.title,
                visible: false,
                hideOnOutsideClick: true,
                showCloseButton: false,
                toolbarItems: [{
                    widget: 'dxButton',
                    toolbar: 'top',
                    location: 'after',
                    options: {
                        stylingMode: 'text',
                        text: '',
                        hint: 'Refresh',
                        icon: 'refresh',
                        onClick() {
                            load(config);
                            tabComponent.option("dataSource", config.tabs);
                        },
                    },
                }, {
                    widget: 'dxButton',
                    toolbar: 'top',
                    location: 'after',
                    options: {
                        stylingMode: 'text',
                        text: '',
                        hint: 'Close',
                        icon: 'close',
                        onClick() {
                            popupComponent.hide();
                        },
                    },
                }, {
                    widget: 'dxButton',
                    toolbar: 'bottom',
                    location: 'after',
                    options: {
                        text: 'Close',
                        onClick() {
                            popupComponent.hide();
                        },
                    },
                }],
                onInitialized(e) {
                    popupComponent = e.component;
                    popupComponent.show();
                }
            } as DevExpress.ui.dxPopover.Properties;

            let $popover = $(`
            <div data-bind="dxPopup: popupOptions">
                <foreign-key-info></foreign-key-info>
            </div>`);
            $popover.appendTo('body');

            ko.applyBindings({ popupOptions }, $popover[0]);
        }
    }

    function load(config: IForeignKeyInfoParams) {
        let o = {
            url: config.url,
            async: false,
            verb: "GET",
            successFunction(data, e) {
                if (data) {
                    config.tabs = config.createTabs(data);
                    //if (!dontSelectFirstTab) {
                    //    tab.option("selectedIndex", 0);
                    //}
                }
                else {
                    config.tabs = [];
                }
            },
            failureFunction(textStatus, errorThrown, errorItem) {

            }
        } as RequestServerParams;
        irGlobal.requestServerAdmin(o);
    }
}